/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *
 *******************************************************************************/

import React from 'react'


 import { useEffect } from 'react'
import AI from '../../../components/Page/AI'




const AIPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);

     }, [])
 
        return (
            <>


                <AI />

            </>
        )
 }

 
 export default AIPage;
